import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'mx-a md:w-max space-y-4',
    label: 'text-center text-sm'
  },
  brandStyles: {
    container: {
      'min-w': {
        sm: '100%',
        md: '18rem',
      }
    }
  },
  buttonSize: 'md',
  previousNextVariant: 'secondary'
} satisfies RecursivePartial<ProductConfig['pagination']>
